// import React, { useState, useEffect } from "react";
// import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";

// const VIPScanner = () => {
//     const [scanResults, setScanResults] = useState([]); // Store all scanned data
//     const [lastScanned, setLastScanned] = useState(""); // Most recent scanned item
//     const [cameraId, setCameraId] = useState(null); // Store the back camera ID
//     const [scanner, setScanner] = useState(null); // Store the Html5Qrcode scanner instance
//     const [showTick, setShowTick] = useState(false); // Show success tick
//     const [showCross, setShowCross] = useState(false); // Show error cross
//     const [lastScanTime, setLastScanTime] = useState(0); // Prevent duplicate scans
//     const [errorMessage, setErrorMessage] = useState(null); // Display error messages

//     const ERROR_MESSAGES = {
//         INVALID_QR: "Invalid QR code format.",
//         INVALID_DATE: "Invalid date in QR code.",
//         INVALID_COUNT: "Invalid count in QR code.",
//         ALREADY_SCANNED: "This QR code has already been scanned.",
//         SAVE_ERROR: "An error occurred while saving the scan data.",
//     };

//     // const QR_CODE_REGEX = /^Date:\s(\d{2}-\d{2}-\d{4}),\sCount:\s(\d+)$/;
//     const QR_CODE_REGEX = /^https:\/\/khasdarmahotsav\.com\/registration\/2025\/([A-Fa-f0-9]+)$/;

//     useEffect(() => {
//         // Initialize scanner and fetch cameras
//         Html5Qrcode.getCameras()
//             .then((devices) => {
//                 if (devices.length > 0) {
//                     const backCamera = devices.find((device) =>
//                         device.label.toLowerCase().includes("back")
//                     );
//                     setCameraId(backCamera ? backCamera.id : devices[0].id);
//                 } else {
//                     // console.error("No cameras found!");
//                 }
//             })
//             .catch(
//             // (err) => console.error("Error fetching cameras:", err)
//         );
//     }, []);

//     useEffect(() => {
//         if (cameraId) {
//             const html5QrCode = new Html5Qrcode("qr-reader", {
//                 formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
//             });

//             html5QrCode
//                 .start(
//                     cameraId,
//                     { fps: 10, qrbox: { width: 300, height: 300 }, aspectRatio: 1.0 },
//                     handleScanSuccess,
//                     // (error) => console.error("Scanning Error:", error)
//                 )
//                 .then(() => setScanner(html5QrCode))
//                 .catch(
//                 // (err) => console.error("Error starting scanner:", err)
//             );

//             return () => {
//                 html5QrCode.stop().catch(
//                     // (err) =>
//                     // console.error("Error stopping scanner:", err)
//                 );
//             };
//         }
//     }, [cameraId]);

//     const handleScanSuccess = async (decodedText) => {
//         const currentTime = Date.now();

//         // Prevent duplicate scans within 2 seconds
//         if (decodedText === lastScanned && currentTime - lastScanTime < 2000) {
//             return;
//         }

//         const match = decodedText.match(QR_CODE_REGEX);
//         if (!match) {
//             showError(ERROR_MESSAGES.INVALID_QR);
//             return;
//         }
//         console.log("Scanned QR Code:", decodedText);
//         // console.log("Regex Match:", match);
//         const scannedCount = match[1];
//         // const scannedCount = parseInt(match[2], 10);

//         // if (!validateDate(scannedDate)) {
//         //     showError(ERROR_MESSAGES.INVALID_DATE);
//         //     return;
//         // }

//         if (scannedCount <= 0) {
//             showError(ERROR_MESSAGES.INVALID_COUNT);
//             return;
//         }

//         setLastScanned(decodedText);
//         setLastScanTime(currentTime);
//         setScanResults((prevResults) => [
//             ...prevResults,
//             {
//                 // date: scannedDate, 
//                 count: scannedCount
//             },
//         ]);
//         setShowTick(true);

//         try {
//             const response = await fetch("/api/vip/scan/data", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ hexaCode: scannedCount }),
//             });

//             const data = await response.json();

//             if (response.ok) {
//                 console.log("Scan data saved successfully");
//             } else if (data.status === "already_scanned") {
//                 showError(ERROR_MESSAGES.ALREADY_SCANNED);
//             } else {
//                 showError(data.message || ERROR_MESSAGES.SAVE_ERROR);
//             }
//         } catch (err) {
//             console.error("Error saving scan data:", err);
//             showError(ERROR_MESSAGES.SAVE_ERROR);
//         }

//         setTimeout(() => setShowTick(false), 1000);
//     };

//     const validateDate = (date) => {
//         const [day, month, year] = date.split("-").map(Number);
//         return (
//             day >= 1 &&
//             day <= 31 &&
//             month >= 1 &&
//             month <= 12 &&
//             year >= 2000 &&
//             year <= 2100
//         );
//     };

//     const showError = (message) => {
//         setShowCross(true);
//         setErrorMessage(message);
//         setTimeout(() => {
//             setShowCross(false);
//             setErrorMessage(null);
//         }, 2000);
//     };

//     return (
//         <div style={styles.container}>
//             <img src="/khasdar.jpg" alt="Logo" style={styles.logo} />
//             <h1 style={styles.title}>VIP Scanner</h1>
//             <div id="qr-reader" style={styles.qrReader}></div>

//             {showTick && <div style={styles.tick}>✅</div>}
//             {showCross && <div style={styles.cross}>❌</div>}
//             {errorMessage && <div style={styles.errorMessage}>{errorMessage}</div>}
//             {lastScanned && (
//                 <div style={styles.lastScanned}>
//                     <strong>Scanned:</strong> {lastScanned}
//                 </div>
//             )}
//         </div>
//     );
// };

// const styles = {
//     container: {
//         textAlign: "center",
//         fontFamily: "Arial, sans-serif",
//         padding: "20px",
//         background: "linear-gradient(135deg, #5ee7df, #b490ca)",
//         color: "#fff",
//         minHeight: "100vh",
//     },
//     title: {
//         fontSize: "24px",
//         fontWeight: "bold",
//         marginBottom: "20px",
//         //text in middle
//         textAlign: "center",
//     },
//     logo: {
//         width: "100px",
//         marginBottom: "20px",
//     },
//     qrReader: {
//         width: "100%",
//         maxWidth: "400px",
//         margin: "auto",
//         border: "5px solid #fff",
//         borderRadius: "10px",
//         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
//     },
//     tick: {
//         fontSize: "48px",
//         color: "#28a745",
//         fontWeight: "bold",
//         margin: "20px 0",
//     },
//     cross: {
//         fontSize: "48px",
//         color: "red",
//         fontWeight: "bold",
//         margin: "20px 0",
//     },
//     errorMessage: {
//         color: "red",
//         fontSize: "18px",
//         margin: "10px 0",
//     },
//     lastScanned: {
//         fontSize: "18px",
//         color: "#fff",
//         marginTop: "10px",
//     },
// };

// export default VIPScanner;

// import React, { useState, useEffect, useRef } from "react";
// import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";

// const VIPScanner = () => {
//     const [scanResults, setScanResults] = useState([]);
//     const [lastScanned, setLastScanned] = useState("");
//     const [cameraId, setCameraId] = useState(null);
//     const [scanner, setScanner] = useState(null);
//     const [showTick, setShowTick] = useState(false);
//     const [showCross, setShowCross] = useState(false);
//     const [lastScanTime, setLastScanTime] = useState(0);
//     const [errorMessage, setErrorMessage] = useState(null);
//     const [successMessage, setSuccessMessage] = useState(null);
//     const [isProcessing, setIsProcessing] = useState(false);

//     // Use refs to track processing state and scanned codes
//     const isProcessingRef = useRef(false);
//     const processedCodesRef = useRef(new Set());
//     const scanTimeoutRef = useRef(null);

//     const ERROR_MESSAGES = {
//         INVALID_QR: "Invalid QR code format.",
//         INVALID_COUNT: "Invalid hexa code in QR code.",
//         NOT_REGISTERED: "This link is not valid.",
//         NOT_ACTIVATED: "The Smart Card is not activated yet.",
//         ALREADY_MARKED: "Attendance already marked for today.",
//         SAVE_ERROR: "An error occurred while saving the scan data.",
//         NETWORK_ERROR: "Network error. Please check your connection.",
//     };

//     const QR_CODE_REGEX = /^https:\/\/khasdarmahotsav\.com\/registration\/2025\/([A-Fa-f0-9]+)$/;
//     const SCAN_COOLDOWN = 5000; // 5 seconds cooldown between scans

//     useEffect(() => {
//         Html5Qrcode.getCameras()
//             .then((devices) => {
//                 if (devices.length > 0) {
//                     const backCamera = devices.find((device) =>
//                         device.label.toLowerCase().includes("back")
//                     );
//                     setCameraId(backCamera ? backCamera.id : devices[0].id);
//                 }
//             })
//             .catch((err) => {
//                 console.error("Error fetching cameras:", err);
//                 showError("Failed to access camera");
//             });

//         // Cleanup on unmount
//         return () => {
//             if (scanTimeoutRef.current) {
//                 clearTimeout(scanTimeoutRef.current);
//             }
//         };
//     }, []);

//     useEffect(() => {
//         if (cameraId) {
//             const html5QrCode = new Html5Qrcode("qr-reader", {
//                 formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
//             });

//             html5QrCode
//                 .start(
//                     cameraId,
//                     { fps: 10, qrbox: { width: 300, height: 300 }, aspectRatio: 1.0 },
//                     handleScanSuccess,
//                     (error) => {
//                         // Silent error handling for continuous scanning
//                     }
//                 )
//                 .then(() => setScanner(html5QrCode))
//                 .catch((err) => {
//                     console.error("Error starting scanner:", err);
//                     showError("Failed to start scanner");
//                 });

//             return () => {
//                 html5QrCode.stop().catch((err) =>
//                     console.error("Error stopping scanner:", err)
//                 );
//             };
//         }
//     }, [cameraId]);

//     const handleScanSuccess = async (decodedText) => {
//         const currentTime = Date.now();

//         // Check if already processing
//         if (isProcessingRef.current) {
//             return;
//         }

//         // Check if same code was scanned recently
//         if (currentTime - lastScanTime < SCAN_COOLDOWN) {
//             return;
//         }

//         // Validate QR code format
//         const match = decodedText.match(QR_CODE_REGEX);
//         if (!match) {
//             showError(ERROR_MESSAGES.INVALID_QR);
//             return;
//         }

//         const hexaCode = match[1];

//         // Check if this code was already processed in this session
//         if (processedCodesRef.current.has(hexaCode)) {
//             showError(ERROR_MESSAGES.ALREADY_MARKED);
//             return;
//         }

//         if (!hexaCode || hexaCode.length === 0) {
//             showError(ERROR_MESSAGES.INVALID_COUNT);
//             return;
//         }

//         // Set processing state
//         isProcessingRef.current = true;
//         setIsProcessing(true);
//         setLastScanned(decodedText);
//         setLastScanTime(currentTime);

//         try {
//             const response = await fetch("/api/vip/scan/data", {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ 
//                     hexaCode,
//                     scannedBy: "Scanner",
//                     deviceInfo: navigator.userAgent 
//                 }),
//             });

//             const data = await response.json();

//             if (response.ok && data.status === "success") {
//                 // Success - add to processed codes
//                 processedCodesRef.current.add(hexaCode);

//                 setScanResults((prevResults) => [
//                     ...prevResults,
//                     {
//                         hexaCode,
//                         timestamp: new Date().toISOString(),
//                     },
//                 ]);

//                 showSuccess(data.message || "Attendance marked successfully!");

//                 // Remove from processed codes after cooldown period
//                 scanTimeoutRef.current = setTimeout(() => {
//                     processedCodesRef.current.delete(hexaCode);
//                 }, SCAN_COOLDOWN);
//             } else {
//                 // Handle different error statuses
//                 let errorMsg = ERROR_MESSAGES.SAVE_ERROR;

//                 switch(data.status) {
//                     case "not_registered":
//                         errorMsg = ERROR_MESSAGES.NOT_REGISTERED;
//                         break;
//                     case "registration_incomplete":
//                         errorMsg = ERROR_MESSAGES.NOT_ACTIVATED;
//                         break;
//                     case "already_marked":
//                         errorMsg = ERROR_MESSAGES.ALREADY_MARKED;
//                         processedCodesRef.current.add(hexaCode);
//                         break;
//                     default:
//                         errorMsg = data.message || ERROR_MESSAGES.SAVE_ERROR;
//                 }

//                 showError(errorMsg);
//             }
//         } catch (err) {
//             console.error("Error saving scan data:", err);
//             showError(ERROR_MESSAGES.NETWORK_ERROR);
//         } finally {
//             // Reset processing state after a delay
//             setTimeout(() => {
//                 isProcessingRef.current = false;
//                 setIsProcessing(false);
//             }, 1000);
//         }
//     };

//     const showSuccess = (message) => {
//         setSuccessMessage(message);
//         setShowTick(true);
//         setErrorMessage(null);
//         setShowCross(false);

//         setTimeout(() => {
//             setShowTick(false);
//             setSuccessMessage(null);
//         }, 3000);
//     };

//     const showError = (message) => {
//         setErrorMessage(message);
//         setShowCross(true);
//         setSuccessMessage(null);
//         setShowTick(false);

//         setTimeout(() => {
//             setShowCross(false);
//             setErrorMessage(null);
//         }, 3000);
//     };

//     return (
//         <div style={styles.container}>
//             <img src="/khasdar.jpg" alt="Logo" style={styles.logo} />
//             <h1 style={styles.title}>VIP Scanner</h1>

//             <div id="qr-reader" style={styles.qrReader}></div>

//             {isProcessing && (
//                 <div style={styles.processing}>Processing...</div>
//             )}

//             {showTick && <div style={styles.tick}>✅</div>}
//             {showCross && <div style={styles.cross}>❌</div>}

//             {successMessage && (
//                 <div style={styles.successMessage}>{successMessage}</div>
//             )}

//             {errorMessage && (
//                 <div style={styles.errorMessage}>{errorMessage}</div>
//             )}

//             {lastScanned && !isProcessing && (
//                 <div style={styles.lastScanned}>
//                     <strong>Last Scanned:</strong><br />
//                     {lastScanned}
//                 </div>
//             )}

//             {scanResults.length > 0 && (
//                 <div style={styles.resultsContainer}>
//                     <h3>Scan History ({scanResults.length})</h3>
//                     <div style={styles.resultsList}>
//                         {scanResults.slice(-5).reverse().map((result, index) => (
//                             <div key={index} style={styles.resultItem}>
//                                 <strong>Code:</strong> {result.hexaCode}<br />
//                                 <small>{new Date(result.timestamp).toLocaleString()}</small>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// const styles = {
//     container: {
//         textAlign: "center",
//         fontFamily: "Arial, sans-serif",
//         padding: "20px",
//         background: "linear-gradient(135deg, #5ee7df, #b490ca)",
//         color: "#fff",
//         minHeight: "100vh",
//     },
//     title: {
//         fontSize: "24px",
//         fontWeight: "bold",
//         marginBottom: "20px",
//         textAlign: "center",
//     },
//     logo: {
//         width: "100px",
//         marginBottom: "20px",
//     },
//     qrReader: {
//         width: "100%",
//         maxWidth: "400px",
//         margin: "auto",
//         border: "5px solid #fff",
//         borderRadius: "10px",
//         boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
//     },
//     processing: {
//         fontSize: "20px",
//         color: "#fff",
//         fontWeight: "bold",
//         margin: "20px 0",
//         animation: "pulse 1.5s infinite",
//     },
//     tick: {
//         fontSize: "48px",
//         color: "#28a745",
//         fontWeight: "bold",
//         margin: "20px 0",
//     },
//     cross: {
//         fontSize: "48px",
//         color: "#ff4444",
//         fontWeight: "bold",
//         margin: "20px 0",
//     },
//     successMessage: {
//         backgroundColor: "#28a745",
//         color: "#fff",
//         fontSize: "18px",
//         padding: "15px",
//         margin: "10px auto",
//         borderRadius: "8px",
//         maxWidth: "400px",
//         fontWeight: "bold",
//     },
//     errorMessage: {
//         backgroundColor: "#ff4444",
//         color: "#fff",
//         fontSize: "18px",
//         padding: "15px",
//         margin: "10px auto",
//         borderRadius: "8px",
//         maxWidth: "400px",
//         fontWeight: "bold",
//     },
//     lastScanned: {
//         fontSize: "16px",
//         color: "#fff",
//         marginTop: "20px",
//         padding: "10px",
//         backgroundColor: "rgba(255, 255, 255, 0.2)",
//         borderRadius: "8px",
//         maxWidth: "400px",
//         margin: "20px auto",
//         wordBreak: "break-all",
//     },
//     resultsContainer: {
//         marginTop: "30px",
//         backgroundColor: "rgba(255, 255, 255, 0.1)",
//         padding: "20px",
//         borderRadius: "10px",
//         maxWidth: "400px",
//         margin: "30px auto",
//     },
//     resultsList: {
//         marginTop: "10px",
//     },
//     resultItem: {
//         backgroundColor: "rgba(255, 255, 255, 0.2)",
//         padding: "10px",
//         marginBottom: "10px",
//         borderRadius: "5px",
//         textAlign: "left",
//     },
// };

// export default VIPScanner;


import React, { useState, useEffect, useRef } from "react";
import { Html5Qrcode, Html5QrcodeSupportedFormats } from "html5-qrcode";

const VIPScanner = () => {
    const [scanResults, setScanResults] = useState([]);
    const [cameraId, setCameraId] = useState(null);
    const [scanner, setScanner] = useState(null);
    const [showTick, setShowTick] = useState(false);
    const [showCross, setShowCross] = useState(false);
    const [lastScanTime, setLastScanTime] = useState(0);
    const [errorMessage, setErrorMessage] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);
    const [scannedUserName, setScannedUserName] = useState("");

    const isProcessingRef = useRef(false);
    const processedCodesRef = useRef(new Set());
    const scanTimeoutRef = useRef(null);

    const ERROR_MESSAGES = {
        INVALID_QR: "Invalid QR code format.",
        INVALID_COUNT: "Invalid hexa code in QR code.",
        NOT_REGISTERED: "This link is not valid.",
        NOT_ACTIVATED: "The Smart Card is not activated yet.",
        ALREADY_MARKED: "Attendance already marked for today.",
        SAVE_ERROR: "An error occurred while saving the scan data.",
        NETWORK_ERROR: "Network error. Please check your connection.",
    };

    // const QR_CODE_REGEX = /^https:\/\/khasdarmahotsav\.com\/registration\/2025\/([A-Fa-f0-9]+)$/;
    const QR_CODE_REGEX = /\/registration\/2025\/([A-Za-z0-9]+)(?:[/?#]|$)/;

    const SCAN_COOLDOWN = 3000; // 3 seconds cooldown between scans

    useEffect(() => {
        Html5Qrcode.getCameras()
            .then((devices) => {
                if (devices.length > 0) {
                    const backCamera = devices.find((device) =>
                        device.label.toLowerCase().includes("back")
                    );
                    setCameraId(backCamera ? backCamera.id : devices[0].id);
                }
            })
            .catch((err) => {
                console.error("Error fetching cameras:", err);
                showError("Failed to access camera");
            });

        return () => {
            if (scanTimeoutRef.current) {
                clearTimeout(scanTimeoutRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (cameraId) {
            const html5QrCode = new Html5Qrcode("qr-reader", {
                formatsToSupport: [Html5QrcodeSupportedFormats.QR_CODE],
            });

            html5QrCode
                .start(
                    cameraId,
                    { fps: 10, qrbox: { width: 300, height: 300 }, aspectRatio: 1.0 },
                    handleScanSuccess,
                    (error) => {
                        // Silent error handling for continuous scanning
                    }
                )
                .then(() => setScanner(html5QrCode))
                .catch((err) => {
                    console.error("Error starting scanner:", err);
                    showError("Failed to start scanner");
                });

            return () => {
                html5QrCode.stop().catch((err) =>
                    console.error("Error stopping scanner:", err)
                );
            };
        }
    }, [cameraId]);

    const handleScanSuccess = async (decodedText) => {
        // http://localhost:3000/registration/2025/RB765E
        const currentTime = Date.now();

        if (isProcessingRef.current) {
            return;
        }

        if (currentTime - lastScanTime < SCAN_COOLDOWN) {
            return;
        }
        // console.log("decodedText", decodedText)
        // http://localhost:3000/registration/2025/RB765E
        // const match = decodedText.match(QR_CODE_REGEX);
        const cleanText = decodedText.trim();
        const match = cleanText.match(QR_CODE_REGEX);
        // console.log(match) //null
        if (!match) {
            showError(ERROR_MESSAGES.INVALID_QR);
            return;
        }

        const hexaCode = match[1];
        // console.log("hexaCode", hexaCode)
        if (processedCodesRef.current.has(hexaCode)) {
            showError(ERROR_MESSAGES.ALREADY_MARKED);
            return;
        }

        if (!hexaCode || hexaCode.length === 0) {
            showError(ERROR_MESSAGES.INVALID_COUNT);
            return;
        }

        isProcessingRef.current = true;
        setIsProcessing(true);
        setLastScanTime(currentTime);

        try {
            const response = await fetch("/api/vip/scan/data", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    hexaCode,
                    scannedBy: "Scanner",
                    deviceInfo: navigator.userAgent
                }),
            });

            const data = await response.json();
            // console.log("Response data:", data);
            if (response.ok && data.status === "success") {
                processedCodesRef.current.add(hexaCode);

                // Extract user name from backend response
                const userName = data?.data?.firstName || "User";
                setScannedUserName(userName);

                setScanResults((prevResults) => [
                    ...prevResults,
                    {
                        name: userName,
                        timestamp: new Date().toISOString(),
                    },
                ]);

                showSuccess(`✓ ${userName}`);

                scanTimeoutRef.current = setTimeout(() => {
                    processedCodesRef.current.delete(hexaCode);
                }, SCAN_COOLDOWN);
            } else {
                let errorMsg = ERROR_MESSAGES.SAVE_ERROR;

                switch (data.status) {
                    case "not_registered":
                        errorMsg = ERROR_MESSAGES.NOT_REGISTERED;
                        break;
                    case "registration_incomplete":
                        errorMsg = ERROR_MESSAGES.NOT_ACTIVATED;
                        break;
                    case "already_marked":
                        errorMsg = ERROR_MESSAGES.ALREADY_MARKED;
                        processedCodesRef.current.add(hexaCode);
                        break;
                    default:
                        errorMsg = data.message || ERROR_MESSAGES.SAVE_ERROR;
                }

                showError(errorMsg);
            }
        } catch (err) {
            console.error("Error saving scan data:", err);
            showError(ERROR_MESSAGES.NETWORK_ERROR);
        } finally {
            setTimeout(() => {
                isProcessingRef.current = false;
                setIsProcessing(false);
            }, 800);
        }
    };

    const showSuccess = (message) => {
        setSuccessMessage(message);
        setShowTick(true);
        setErrorMessage(null);
        setShowCross(false);

        setTimeout(() => {
            setShowTick(false);
            setSuccessMessage(null);
        }, 2500);
    };

    const showError = (message) => {
        setErrorMessage(message);
        setShowCross(true);
        setSuccessMessage(null);
        setShowTick(false);

        setTimeout(() => {
            setShowCross(false);
            setErrorMessage(null);
        }, 2500);
    };

    return (
        <div style={styles.container}>
            <img src="/khasdar.jpg" alt="Logo" style={styles.logo} />
            <h1 style={styles.title}>VIP Scanner</h1>

            <div id="qr-reader" style={styles.qrReader}></div>

            {isProcessing && (
                <div style={styles.processing}>Scanning...</div>
            )}

            {showTick && <div style={styles.tick}>✅</div>}
            {showCross && <div style={styles.cross}>❌</div>}

            {successMessage && (
                <div style={styles.successMessage}>{successMessage}</div>
            )}

            {errorMessage && (
                <div style={styles.errorMessage}>{errorMessage}</div>
            )}

            {scanResults.length > 0 && (
                <div style={styles.resultsContainer}>
                    <h3 style={styles.historyTitle}>Recent Scans ({scanResults.length})</h3>
                    <div style={styles.resultsList}>
                        {scanResults.slice(-5).reverse().map((result, index) => (
                            <div key={index} style={styles.resultItem}>
                                <div style={styles.userName}>{result.name}</div>
                                <small style={styles.timestamp}>
                                    {new Date(result.timestamp).toLocaleTimeString()}
                                </small>
                            </div>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

const styles = {
    container: {
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        background: "linear-gradient(135deg, #5ee7df, #b490ca)",
        color: "#fff",
        minHeight: "100vh",
    },
    title: {
        fontSize: "28px",
        fontWeight: "bold",
        marginBottom: "20px",
        textAlign: "center",
    },
    logo: {
        width: "120px",
        marginBottom: "20px",
    },
    qrReader: {
        width: "100%",
        maxWidth: "400px",
        margin: "auto",
        border: "5px solid #fff",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
    },
    processing: {
        fontSize: "20px",
        color: "#fff",
        fontWeight: "bold",
        margin: "15px 0",
    },
    tick: {
        fontSize: "64px",
        margin: "15px 0",
    },
    cross: {
        fontSize: "64px",
        margin: "15px 0",
    },
    successMessage: {
        backgroundColor: "#28a745",
        color: "#fff",
        fontSize: "24px",
        padding: "20px",
        margin: "15px auto",
        borderRadius: "12px",
        maxWidth: "400px",
        fontWeight: "bold",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
    },
    errorMessage: {
        backgroundColor: "#ff4444",
        color: "#fff",
        fontSize: "18px",
        padding: "20px",
        margin: "15px auto",
        borderRadius: "12px",
        maxWidth: "400px",
        fontWeight: "bold",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)",
    },
    resultsContainer: {
        marginTop: "30px",
        backgroundColor: "rgba(255, 255, 255, 0.15)",
        padding: "20px",
        borderRadius: "12px",
        maxWidth: "400px",
        margin: "30px auto",
    },
    historyTitle: {
        fontSize: "18px",
        marginBottom: "15px",
    },
    resultsList: {
        marginTop: "10px",
    },
    resultItem: {
        backgroundColor: "rgba(255, 255, 255, 0.25)",
        padding: "15px",
        marginBottom: "10px",
        borderRadius: "8px",
        textAlign: "center",
    },
    userName: {
        fontSize: "20px",
        fontWeight: "bold",
        marginBottom: "5px",
    },
    timestamp: {
        fontSize: "14px",
        opacity: 0.8,
    },
};

export default VIPScanner;